<template>
  <div class='port'>
      <ul>
        <li v-for="img in portfolio" :key="img.image.id" style="display:inline-block;width:10%">
            <a target="_blank" :href='"https://opensea.io/assets/0xc7Fb5Ea543819dd0574B6644A6B7750C452aDc89/" + img.image.id'><img :src="img.image.image"/></a>
        </li>
      </ul>
      
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { shorten } from '@/helpers/utils';

export default {
  data() {
    return {
    };
  },

  computed: mapState({
    address: state => state.settings.address,
    portfolio: state => state.settings.portfolio

  }),
  methods: {
    shorten
  }
};
</script>

<style scoped>
ul{
  height: auto;
  display: flex;
  flex-flow: row;
  overflow-y: hidden;
  width: max-content;
}
li{  
  display: inline-block;
  width: min-content;}
.port {
  width: 95%;
  margin-left: 2.5%;
  margin-right: 2.5%;
  position: fixed;
  bottom: 5vh;
  background: #fff;
  z-index: 1000;
  border-radius: 20px;
  overflow-x: scroll;
  color: #000;
  max-height: calc(200px + 4rem);
  overflow-y: hidden;
  border: 1rem solid white;
}

h1 {
    color: black;
    margin: 10px;
    font-size:1em;
}
img {  
    margin: 1rem;
    border-radius: 0rem;
    width: 200px;
    min-width: 30px;
    max-height:100%;
    background:#e1e1e1;
    border:1px solid #1111;    
}
</style>
